import { render, staticRenderFns } from "./PrevRoundScore.vue?vue&type=template&id=053c5696&scoped=true&"
import script from "./PrevRoundScore.vue?vue&type=script&lang=js&"
export * from "./PrevRoundScore.vue?vue&type=script&lang=js&"
import style0 from "./PrevRoundScore.vue?vue&type=style&index=0&id=053c5696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c5696",
  null
  
)

export default component.exports